import React, { useState } from 'react';
import { Navbar, Nav, Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../store/slices/authSlice';
import { IconUser, IconLogOut, IconMenu, IconBarChart } from '../Icons';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import ChatBell from '../Chat/ChatBell';
import { hasRole } from '../../utils/roleList';

const Header: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);
  const [expanded, setExpanded] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <Navbar bg="primary" variant="dark" expand="lg" expanded={expanded}>
      <div className="container-fluid">
        <Navbar.Brand
          href="/products"
          className="fw-bold"
          onClick={(e) => {
            e.preventDefault();
            navigate('/products');
            setExpanded(false);
          }}
        >
          new_products
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded(!expanded)}
        >
          <IconMenu />
        </Navbar.Toggle>

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link
              onClick={() => {
                navigate('/products');
                setExpanded(false);
              }}
            >
              Товары
            </Nav.Link>
            <Nav.Link
              onClick={() => {
                navigate('/new-products');
                setExpanded(false);
              }}
            >
              Новые товары
            </Nav.Link>
            <Nav.Link
              onClick={() => {
                navigate('/technical-specs');
                setExpanded(false);
              }}
            >
              Технические задания
            </Nav.Link>
            <Nav.Link
              onClick={() => {
                navigate('/new-wave');
                setExpanded(false);
              }}
            >
              New Wave
            </Nav.Link>
            <Nav.Link
              onClick={() => {
                navigate('/manual-product');
                setExpanded(false);
              }}
            >
              Ручной товар
            </Nav.Link>
            <Nav.Link
              onClick={() => {
                navigate('/data-sources');
                setExpanded(false);
              }}
            >
              Источники
            </Nav.Link>
            {hasRole(user?.role, 'admin') && (
              <Nav.Link
                onClick={() => {
                  navigate('/admin');
                  setExpanded(false);
                }}
              >
                Админ панель
              </Nav.Link>
            )}
          </Nav>

          <Nav className="align-items-center">
            <ChatBell />
            <Dropdown align="end">
              <Dropdown.Toggle
                variant="outline-light"
                id="dropdown-basic"
                className="d-flex align-items-center"
              >
                <IconUser className="me-2" />
                <span className="d-none d-md-inline">
                  {user?.username || user?.email || 'Пользователь'}
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => {
                    navigate('/statistics');
                    setExpanded(false);
                  }}
                >
                  <IconBarChart className="me-2" />
                  Статистика
                </Dropdown.Item>
                <Dropdown.Item onClick={handleLogout}>
                  <IconLogOut className="me-2" />
                  Выйти
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};

export default Header;
